import { InjectionToken } from '@angular/core';
import { OpenIdConfiguration } from 'angular-auth-oidc-client';

export const POST_LOGIN_URL = 'post_login_url';

export interface OAuthConfig {
    loadConfig: () => OpenIdConfiguration;
}

export const OAUTH_CONFIG = new InjectionToken<readonly OAuthConfig[]>('oauth configuration');
